import { Modal, Button } from "@similarweb/ui-components";
import { Text, Flex } from "@similarweb/ui-components/foundations";

interface IConfirmationModalProps {
    isOpen: boolean;
    title: string;
    confirmationText: string;
    cancelText: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmationModal = ({
    isOpen,
    title,
    confirmationText,
    cancelText,
    onConfirm,
    onCancel,
}: IConfirmationModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            customStyles={{ content: { width: "400px" } }}
        >
            <Modal.Title>
                <Flex padding="20px 24px">
                    <Text fontVariant="h5_2">{title}</Text>
                </Flex>
            </Modal.Title>
            <Modal.Footer>
                <Flex
                    width="100%"
                    justifyContent="space-between"
                >
                    <Button
                        type="flatDark"
                        onClick={() => onCancel()}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        type="warning"
                        onClick={() => onConfirm()}
                    >
                        {confirmationText}
                    </Button>
                </Flex>
            </Modal.Footer>
        </Modal>
    );
};
